module.exports = __webpack_public_path__ + "static/media/IMG_0802.90d44266.jpg";